import { useState } from 'react';
import PropTypes from 'prop-types';
import { InputControlled } from 'components/UI/InputControlled/InputControlled';
import { DropdownWithMenu } from 'components/UI/DropdownWithMenu/DropdownWithMenu';
import { ReactComponent as HelpIcon } from 'assets/icons/svgs/icon-help.svg';
import useWindowDimensions from 'hooks/use-window-dimensions';
import './AccountInformation.scss';

export const AddressFormSection = (props) => {
  const {
    States,
    Countries,
    selectedState,
    setSelectedState,
    selectedCountry,
    setSelectedCountry,
    selectedStateDescription,
    selectedCountryChangeHandler,
  } = props;
  const [openPopup, setOpenPopup] = useState(false);
  const { isMobile } = useWindowDimensions();
  const popupHintClass = isMobile ? 'hint-visible-m' : 'hint-visible-d';
  const popupOpenClass = openPopup === 'postcode' ? popupHintClass : '';
  const postcodePopupClasses = ['form-hint', popupOpenClass].join(' ');
  const stateDropDownOptions = States.map((state) => ({
    key: state.StateCode,
    name: state.Description,
  }));

  const countryDropDownOptions = Countries.map((country) => ({
    key: country.Description,
    name: country.Description,
  }));

  const stateDropdownUpdateHandler = (state) => {
    setSelectedState(state);
  };

  const countryDropdownUpdateHandler = async (country) => {
    setSelectedCountry(country);
    selectedCountryChangeHandler(country);
  };

  const showPopupHandler = (inputId) => {
    if (!isMobile) {
      setOpenPopup(inputId);
    }
  };

  const showPopupMobileHandler = (inputId) => {
    setOpenPopup((prevState) => (prevState ? false : inputId));
  };

  return (
    <div className="form-section">
      <h2 className="h4">Address information</h2>

      <div className="form-group">
        <InputControlled type="text" id="deliveryAddress1" labelText="Address Line 1" />
      </div>

      <div className="form-group">
        <InputControlled type="text" id="deliveryAddress2" labelText="Address Line 2" />
      </div>

      <div className="form-group">
        <InputControlled type="text" id="suburb" labelText="Suburb" />
      </div>

      <div className="form-group has-hint">
        <InputControlled
          type="text"
          id="postcode"
          labelText="Postcode"
          showPopupHandler={showPopupHandler}
        />
        <button
          type="button"
          className="hint-btn visible-xs"
          onClick={() => showPopupMobileHandler('postcode')}
        >
          <HelpIcon className="registration-form__help-icon" />
        </button>
        <div className={postcodePopupClasses}>
          <p>If you have an international postcode that is not accepted, please enter 0000.</p>
        </div>
      </div>

      <div className="form-group">
        <DropdownWithMenu
          singleColumn
          hideDefaultItem
          dropdownChangeHandler={stateDropdownUpdateHandler}
          defaultChosenValue={selectedStateDescription}
          defaultValue={selectedState}
          updatedChosenValue={selectedStateDescription}
          menuData={stateDropDownOptions}
        />
      </div>

      <div className="form-group">
        <DropdownWithMenu
          singleColumn
          hideDefaultItem
          dropdownChangeHandler={countryDropdownUpdateHandler}
          defaultChosenValue={selectedCountry}
          defaultValue={selectedCountry}
          menuData={countryDropDownOptions}
        />
      </div>
    </div>
  );
};

AddressFormSection.propTypes = {
  States: PropTypes.array,
  Countries: PropTypes.array,
  selectedState: PropTypes.string,
  setSelectedState: PropTypes.func,
  selectedCountry: PropTypes.string,
  setSelectedCountry: PropTypes.func,
  selectedStateDescription: PropTypes.string,
  selectedCountryChangeHandler: PropTypes.func,
};
